import { objectWithoutProperties as _objectWithoutProperties, objectSpread2 as _objectSpread2, slicedToArray as _slicedToArray, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.esm.js';
import { mergeRefs } from '@costar-ui/utils';
import React, { forwardRef, useRef, useState, useMemo } from 'react';
import { composeRenderProps, Input as Input$1 } from 'react-aria-components';
import { useComponentTheme } from '../../../theme/theme.context.esm.js';
import { useComponentVariant } from '../../../theme/variant.context.esm.js';

var _excluded = ["textVariant"],
  _excluded2 = ["alignItems", "canShrink", "className", "color", "direction", "ellipsis", "fullHeight", "fullWidth", "gap", "gapCol", "gapRow", "inline", "justify", "leading", "padding", "paddingX", "paddingY", "size", "testId", "title", "tracking", "weight"];
var Input = /*#__PURE__*/forwardRef(function Input(_ref, ref) {
  var _localRef$current;
  var textVariant = _ref.textVariant,
    props = _objectWithoutProperties(_ref, _excluded);
  var textVariantProps = useComponentVariant('Text', textVariant);
  var theme = useComponentTheme('Input');
  var _textVariantProps$pro = _objectSpread2(_objectSpread2({}, textVariantProps), props),
    _textVariantProps$pro2 = _textVariantProps$pro.alignItems,
    alignItems = _textVariantProps$pro2 === void 0 ? 'center' : _textVariantProps$pro2,
    canShrink = _textVariantProps$pro.canShrink,
    _textVariantProps$pro3 = _textVariantProps$pro.className,
    _className = _textVariantProps$pro3 === void 0 ? '' : _textVariantProps$pro3,
    color = _textVariantProps$pro.color,
    _textVariantProps$pro4 = _textVariantProps$pro.direction,
    direction = _textVariantProps$pro4 === void 0 ? 'horizontal' : _textVariantProps$pro4,
    ellipsis = _textVariantProps$pro.ellipsis,
    fullHeight = _textVariantProps$pro.fullHeight,
    fullWidth = _textVariantProps$pro.fullWidth,
    gap = _textVariantProps$pro.gap,
    gapCol = _textVariantProps$pro.gapCol,
    gapRow = _textVariantProps$pro.gapRow,
    inline = _textVariantProps$pro.inline,
    _textVariantProps$pro5 = _textVariantProps$pro.justify,
    justify = _textVariantProps$pro5 === void 0 ? 'start' : _textVariantProps$pro5,
    leading = _textVariantProps$pro.leading,
    padding = _textVariantProps$pro.padding,
    paddingX = _textVariantProps$pro.paddingX,
    paddingY = _textVariantProps$pro.paddingY,
    size = _textVariantProps$pro.size,
    testId = _textVariantProps$pro.testId,
    _title = _textVariantProps$pro.title,
    tracking = _textVariantProps$pro.tracking,
    weight = _textVariantProps$pro.weight,
    rest = _objectWithoutProperties(_textVariantProps$pro, _excluded2);
  var localRef = useRef(null);
  var isTruncated = !!ellipsis;
  // Define state and function to update the value
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showTitle = _useState2[0],
    setShowTitle = _useState2[1];
  var title = (_title !== null && _title !== void 0 ? _title : isTruncated) ? "".concat(((_localRef$current = localRef.current) === null || _localRef$current === void 0 ? void 0 : _localRef$current.value) || '') : '';
  var classes = useMemo(function () {
    return composeRenderProps(_className, function (className, renderProps) {
      if (renderProps.isHovered) {
        var compare = !!localRef.current && (localRef.current.scrollWidth > localRef.current.clientWidth || localRef.current.scrollHeight > localRef.current.clientHeight);
        setShowTitle(compare);
      }
      var classes = theme(_objectSpread2(_objectSpread2({}, renderProps), {}, {
        canShrink: canShrink,
        className: className,
        color: color,
        alignItems: alignItems,
        direction: direction,
        ellipsis: ellipsis,
        fullHeight: fullHeight,
        fullWidth: fullWidth,
        gap: gap,
        gapCol: gapCol,
        gapRow: gapRow,
        inline: inline,
        justify: justify,
        leading: leading,
        padding: padding,
        paddingX: paddingX,
        paddingY: paddingY,
        size: size,
        tracking: tracking,
        weight: weight
      }));
      return "csg-tw-input ".concat(classes);
    });
  }, [_className, canShrink, color, alignItems, direction, ellipsis, fullHeight, fullWidth, gap, gapCol, gapRow, inline, justify, leading, padding, paddingX, paddingY, size, theme, tracking, weight]);
  return /*#__PURE__*/React.createElement(Input$1
  // @ts-ignore
  , _extends({
    ref: mergeRefs(ref, localRef),
    className: classes,
    "data-testid": testId,
    title: showTitle ? title !== null && title !== void 0 ? title : '' : ''
  }, rest));
});
Input.displayName = 'Input';

export { Input as default };
//# sourceMappingURL=input.esm.js.map
